import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import config from '@/config/env'
import { get, set } from 'idb-keyval'
const parseVersion = (str) => +str.replace(/\D/g, '')

const checkversion = async () => {
  try {
    const response = await fetch(`${window.location.origin}/meta.json?ts=${Date.now()}`, {
      cache: 'no-store',
    })
    const meta = await response.json()

    if (meta?.version) {
      const metaVersion = parseVersion(meta.version)
      const packageVersion = await get('version')

      if (!packageVersion || packageVersion != metaVersion) {
        await set('version', metaVersion)
        if (config.ENVIRONMENT === 'DEV' && 'serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations()
          await Promise.all(regs.map((r) => r.unregister()))
          console.info('Desregistrando Service Worker...')
          if ('caches' in window) {
            const keys = await caches.keys()
            await Promise.all(keys.map((k) => caches.delete(k)))
          }
        }
        const url = new URL(window.location.href)
        url.searchParams.set('v', meta.version)
        window.location.replace(url.toString())
      }
    }
  } catch (error) {
    console.error('Error al obtener meta.json:', error)
  }
}

const useCacheBuster = () => {
  const location = useLocation()

  useEffect(() => {
    checkversion()
  }, [location])

  return null
}

export default useCacheBuster
export { checkversion }
